import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Calendar } from "../../assets/svg";

const DateInput = ({
  selected,
  onChange,
  className,
  pickerClassName,
  placeholder,
  ...props
}) => {
  const datePickerRef = useRef(null);

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (!value) return;
    const numericValue = value.replace(/[^0-9]/g, "");
    let formattedValue = numericValue;

    if (numericValue.length > 2) {
      formattedValue = `${numericValue.slice(0, 2)}/${numericValue.slice(2)}`;
    }
    if (numericValue.length > 4) {
      formattedValue = `${numericValue.slice(0, 2)}/${numericValue.slice(
        2,
        4
      )}/${numericValue.slice(4, 8)}`;
    }
    e.target.value = formattedValue;
  };

  return (
    <div
      className={`flex items-center justify-between bg-[#2C2D36] border-[#444444] border rounded-full px-4 py-4 ${
        className ?? ""
      }`}
    >
      <DatePicker
        selected={selected}
        onChange={onChange}
        className={`bg-[#2C2D36] outline-none placeholder-[#5d5d64] w-full text-sm ${
          pickerClassName ?? ""
        }`}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        yearDropdownItemNumber={120}
        placeholderText={placeholder}
        dateFormat="MM/dd/yyyy"
        ref={datePickerRef}
        onChangeRaw={handleInputChange}
        {...props}
      />
      <Calendar
        className="flex-shrink-0 cursor-pointer"
        onClick={handleIconClick}
      />
    </div>
  );
};

export default DateInput;
